var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9748 25.9483C12.8429 25.9386 9.89533 24.4668 8.00577 21.9692L8.80433 21.3677C10.6614 23.8272 13.648 25.1652 16.7195 24.9138C19.7911 24.6623 22.5203 22.8564 23.9526 20.1276C25.9158 16.388 25.0136 11.7863 21.7837 9.06482C18.5538 6.34338 13.8657 6.23488 10.5133 8.804C7.16094 11.3731 6.04683 15.9282 7.83493 19.7546L6.92893 20.1764C5.06155 16.1568 6.07077 11.387 9.40626 8.4682C12.7417 5.54939 17.6032 5.18181 21.3397 7.56592C25.0761 9.95003 26.791 14.5138 25.5493 18.7686C24.3075 23.0233 20.407 25.9482 15.9748 25.9483ZM14.0776 20.9577L9.98165 16.8127L10.7286 16.0147L14.0666 19.3947L21.2246 11.9577L21.9816 12.7447L14.0776 20.9577Z",
    fill: "#009688"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.cdaf9092bf4f248d79c44dedcf8d160c.svg";
export { ForwardRef as ReactComponent };